import type { Promotion } from '@/app/lib/types'

/**
 * FR-008/FR-008a: como máximo una promoción especial vigente por evento. Si
 * llegara más de una (situación no esperada por negocio), se toma la primera
 * en el orden de llegada del array y el resto se descarta silenciosamente.
 */
export function pickSpecialPromotion(promotions: Promotion[]): Promotion | null {
  return promotions.find((promotion) => promotion.isSpecial) ?? null
}
